import {
    Component,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
    AfterViewInit,
    ViewEncapsulation,
    ChangeDetectorRef
} from '@angular/core';
import { Subject } from 'rxjs';

import {first} from "rxjs/operators";

import { locale as polish } from './../i18n/pl';
import { locale as english } from './../i18n/en';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../../services/componentTitle.service";

import {
    CalendarEvent,
    CalendarEventTimesChangedEvent, CalendarView,
} from 'angular-calendar';
import { addHours, startOfDay } from 'date-fns';

import {DateAdapter} from "@angular/material/core";
import {MatDialog} from "@angular/material/dialog";
import {EmployeeScheduleDialogComponent} from "./../dialog/employeeScheduleDialog.component";
import {ActivatedRoute} from "@angular/router";
import {FormGroup} from "@angular/forms";
import {EmployeeScheduleService} from "../../services/employeeSchedule.service";
import { DatePipe } from '@angular/common'
import {EmployeeSchedule} from "../../models/employeeSchedule";
import {User} from "../../models";


@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'selected-employee-schedule-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './selectedEmpoyeeSchedule.component.html',
    styleUrls: ['./selectedEmpoyeeSchedule.component.html']
})
export class SelectedEmpoyeeScheduleComponent implements OnDestroy, OnInit, AfterViewInit {
    viewDate = new Date();
    locale: string = 'pl';
    processing: boolean = false;
    error: string = '';
    dialogRef: any;
    showMarker: boolean = false;
    private _unsubscribeAll: Subject<any>;
    public destroyed = new Subject<any>();
    view: CalendarView = CalendarView.Month;
    activeDayIsOpen: boolean = true;

    private schedule: any;

    events: CalendarEvent[] = [];
    worker: User;

    constructor(
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private dateAdapter: DateAdapter<any>,
        public _matDialog: MatDialog,
        private route: ActivatedRoute,
        private employeeScheduleService: EmployeeScheduleService,
        public datepipe: DatePipe,
        private cdr: ChangeDetectorRef,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Employee schedule');

        this.dateAdapter.setLocale(this.locale);
    }

    ngAfterViewInit() {

    }

    ngOnInit() {
        this.worker = this.route.snapshot.data.worker;

        this.componentTitleService.addPart(this.worker.firstName + ' ' + this.worker.lastName);

        this.loadEmployeeSchedules();
    }

    ngOnDestroy(): void {
        // this._unsubscribeAll.next();
        // this._unsubscribeAll.complete();
        this.destroyed.next();
        this.destroyed.complete();
    }

    loadEmployeeSchedules() {
        this.events = [];
        var firstDay = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth(), 1);
        var lastDay = new Date(this.viewDate.getFullYear(), this.viewDate.getMonth() + 1, 0);
        this.employeeScheduleService.getByDateAndUser(this.worker.id, firstDay.toISOString().substring(0, 19).replace('T', ' '), lastDay.toISOString().substring(0, 19).replace('T', ' ')).pipe(first())
            .subscribe((schedules: EmployeeSchedule[]) => {
                for (let i = 0; i < schedules.length; i++) {
                    let idx = 0;

                    this.events.push({
                        title: this.datepipe.transform(schedules[i].startDate, 'HH:mm', 'UTC') + ' - ' + this.datepipe.transform(schedules[i].endDate, 'HH:mm', 'UTC'),
                        start: addHours(startOfDay(new Date(schedules[i].startDate)), idx),
                        meta: {
                            user: schedules[i].user.id,
                            schedule: schedules[i],
                            startHour: this.datepipe.transform(schedules[i].startDate, 'HH:mm', 'UTC'),
                            endHour: this.datepipe.transform(schedules[i].endDate, 'HH:mm', 'UTC')
                        },
                        resizable: {
                            beforeStart: false,
                            afterEnd: false,
                        },
                        draggable: false,
                    });
                }

                this.refresh();
            });
    }

    eventTimesChanged({
                          event,
                          newStart,
                          newEnd,
                      }: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        this.events = [...this.events];
    }

    userChanged({ event, newUser }) {
        event.color = newUser.color;
        event.meta.user = newUser;
        this.events = [...this.events];
    }

    eventClicked({ event }: { event: CalendarEvent }): void {
        this.addEmployeeSchedule(event, true);
    }

    sectionClicked(event: any) {
        this.addEmployeeSchedule(event, false);
    }

    public addEmployeeSchedule(schedule: any, existingEvent: boolean) {
        console.log(schedule);
        this.schedule = schedule;
        this.schedule.date = schedule.day.date;
        this.schedule.user = this.worker;
        this.schedule.user.name = this.worker.firstName + ' ' + this.worker.lastName;
        this.dialogRef = this._matDialog.open(EmployeeScheduleDialogComponent, {
            panelClass: 'employee-schedule-form-dialog',
            data: {
                action: existingEvent? 'edit': 'new',
                schedule: schedule,
                locale: this.locale,
                worker: this.worker,
                // workers: this.users
            },
            width: '700px',
        });

        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick().subscribe(_ => {
            // this.confirm();
            console.log('action should be confirmed...');
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if ( !response )
                {
                    this.events = [...this.events];
                    this.refresh();
                    // this.processing = false;
                    return;
                }

                for (let i = 0; i < response.getRawValue().hours.length; i++) {
                    if (response.getRawValue().id) {
                        this.employeeScheduleService.update(response.getRawValue().id, {
                            user: response.getRawValue().userId,
                            description: response.getRawValue().description,
                            startDate: this.datepipe.transform(response.getRawValue().date, 'yyyy-MM-dd') + ' ' + response.getRawValue().hours[i].startHour,
                            endDate: this.datepipe.transform(response.getRawValue().date, 'yyyy-MM-dd') + ' ' + response.getRawValue().hours[i].endHour,
                        }).pipe(first())
                            .subscribe(
                                (data: EmployeeSchedule) => {
                                    let idx = 0;

                                    for (let i = 0; i < this.events.length; i++) {
                                        if (this.events[i].meta.schedule.id !== response.getRawValue().id) {
                                            continue;
                                        }

                                        this.events[i] = {
                                            title: this.datepipe.transform(data.startDate, 'HH:mm', 'UTC') + ' - ' + this.datepipe.transform(data.endDate, 'HH:mm', 'UTC'),
                                            start: addHours(startOfDay(new Date(data.startDate)), idx),
                                            meta: {
                                                user: data.user.id,
                                                schedule: data,
                                                startHour: this.datepipe.transform(data.startDate, 'HH:mm', 'UTC'),
                                                endHour: this.datepipe.transform(data.endDate, 'HH:mm', 'UTC')
                                            },
                                            resizable: {
                                                beforeStart: false,
                                                afterEnd: false,
                                            },
                                            draggable: false,
                                        };
                                    }

                                    this.refresh();
                                });
                    } else {
                        this.employeeScheduleService.create({
                            user: schedule.user.id,
                            description: response.getRawValue().description,
                            startDate: this.datepipe.transform(schedule.date, 'yyyy-MM-dd') + ' ' + response.getRawValue().hours[i].startHour,
                            endDate: this.datepipe.transform(schedule.date, 'yyyy-MM-dd') + ' ' + response.getRawValue().hours[i].endHour,
                        }).pipe(first())
                            .subscribe(
                                (data: EmployeeSchedule) => {
                                    let idx = 0;

                                    this.events.push({
                                        title: this.datepipe.transform(data.startDate, 'HH:mm', 'UTC') + ' - ' + this.datepipe.transform(data.endDate, 'HH:mm', 'UTC'),
                                        start: addHours(startOfDay(new Date(data.startDate)), idx),
                                        meta: {
                                            user: data.user.id,
                                            schedule: data,
                                            startHour: this.datepipe.transform(data.startDate, 'HH:mm', 'UTC'),
                                            endHour: this.datepipe.transform(data.endDate, 'HH:mm', 'UTC')
                                        },
                                        resizable: {
                                            beforeStart: false,
                                            afterEnd: false,
                                        },
                                        draggable: false,
                                    });

                                    this.refresh();
                                });
                    }
                }
            });
    }

    private refresh() {
        this.events = [...this.events];
        this.cdr.detectChanges();
    }

    closeOpenMonthViewDay() {
        this.activeDayIsOpen = false;
    }
}
